import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

export interface WhatsNewSection {
  readonly heading: string;
  readonly body: string;
}

export interface WhatsNewResponse {
  readonly title: string;
  readonly imageUrl: string | null;
  readonly sections: readonly WhatsNewSection[];
}

@Injectable({ providedIn: 'root' })
export class WhatsNewService {
  private readonly http = inject(HttpClient);

  /**
   * Fetches the current What's New content, relayed by the .NET API
   * from the WordPress Help Centre page.
   */
  get(): Observable<WhatsNewResponse> {
    const url = `${environment.serverUrl}/help/whatsNew`;
    return this.http.get<WhatsNewResponse>(url);
  }
}
